import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { rupiah, tanggalID } from "@/lib/format";
import { PageHeader } from "@/components/app/Layout";
import { useAuth } from "@/context/AuthContext";
import Pagination, { usePagination } from "@/components/app/Pagination";
import { toast } from "sonner";
import { Undo2, CheckCircle2 } from "lucide-react";

const JENIS = { pph05: "PPh Final 0,5%", umkm: "PPh Final UMKM 0,5%", spt: "SPT Tahunan OP" };

export default function RiwayatBayarPajak() {
  const { user } = useAuth();
  const canEdit = ["admin", "finance"].includes(user?.role);
  const [items, setItems] = useState([]);
  const load = () => api.get("/tax-payments").then((r) => setItems(r.data)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);
  const { page, setPage, totalPages, paged, total, pageSize } = usePagination(items, 10);

  const undo = async (it) => {
    if (!window.confirm("Batalkan tanda sudah bayar? Pengingat pajak periode ini akan muncul lagi bila masih dalam masa tampil.")) return;
    try { await api.delete(`/tax-payments/${it.id}`); toast.success("Tanda sudah bayar dibatalkan"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <>
      <PageHeader title="Riwayat Bayar Pajak" subtitle="Daftar pengingat pajak yang sudah ditandai sudah bayar (tanggal, nominal, NTPN/kode billing)." />
      <div className="p-4 md:p-8 space-y-4">
        <div className="card-flat overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-xs md:text-sm" data-testid="tax-pay-table">
              <thead><tr className="bg-slate-50 border-b border-slate-200 text-left text-[11px] uppercase tracking-wide text-slate-500">
                <th className="p-3">Tanggal Bayar</th><th className="p-3">Jenis</th><th className="p-3">Periode</th>
                <th className="p-3 text-right">Nominal</th><th className="p-3">NTPN / Kode Billing</th><th className="p-3">Keterangan</th>
                {canEdit && <th className="p-3 text-right">Aksi</th>}
              </tr></thead>
              <tbody>
                {items.length === 0 && <tr><td colSpan={canEdit ? 7 : 6} className="text-center py-10 text-slate-400">Belum ada pajak yang ditandai sudah bayar. Klik "Tandai Sudah Bayar" pada pengingat di Dashboard.</td></tr>}
                {paged.map((it) => (
                  <tr key={it.id} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`tax-pay-row-${it.id}`}>
                    <td className="p-3 whitespace-nowrap"><span className="inline-flex items-center gap-1"><CheckCircle2 size={13} className="text-emerald-600" />{tanggalID(it.tanggal_bayar)}</span></td>
                    <td className="p-3">{JENIS[it.jenis] || it.jenis || "-"}</td>
                    <td className="p-3">{it.periode || "-"}</td>
                    <td className="p-3 text-right font-mono font-semibold">{rupiah(it.nominal)}</td>
                    <td className="p-3 font-mono text-[12px]">{it.ntpn || "-"}</td>
                    <td className="p-3 text-slate-600">{it.keterangan || "-"}</td>
                    {canEdit && (
                      <td className="p-3 text-right">
                        <button onClick={() => undo(it)} className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-rose-600 p-1" data-testid={`tax-pay-undo-${it.id}`}><Undo2 size={13} /> Batalkan</button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination page={page} setPage={setPage} totalPages={totalPages} total={total} pageSize={pageSize} testid="tax-pay-pagination" />
        </div>
      </div>
    </>
  );
}
